/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');

var DepEnforcementDetailsFormView = require('./DepEnforcementDetailsFormView');

var SubmitEnforcement = require('../services/SubmitEnforcement');

var tmplDepEnforcementEditDetailsView = require('../templates/DepEnforcementEditDetailsView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepEnforcementEditDetailsView,

  className: 'dep-enforcement-edit-view container-fluid',

  ui: {
    enforcementDetailsForm: '.enforcement-details-form-container',
    breadcrumb: '.breadcrumb-container',
    submit: '.btn-submit'
  },

  regions: {
    enforcementDetailsForm: '@ui.enforcementDetailsForm',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var enforcement = this.model.get('enforcement') || {};
    var entityIdentifiers = this.model.get('entityIdentifiers') || {};
    var entityName = entityIdentifiers.entityName;
    var enforcementId = this.model.get('enforcementId');
    var entityId = this.model.get('entityId');
    var action = enforcement.action;
    var effectiveDate = enforcement.effectiveDate;

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            link: '#dep/entity/' + entityId + '/enforcement/' + enforcementId + '/dashboard',
            text: action + ' - Effective as of ' + effectiveDate
          },
          {
            text: 'Edit Enforcement Action Details'
          }
        ]
      })
    );

    this.enforcementDetailsForm = new DepEnforcementDetailsFormView({
      model: this.model
    });

    this.showChildView('enforcementDetailsForm', this.enforcementDetailsForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = this.getFormData();
        SubmitEnforcement(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:dp:enforcement', formData.entityId, formData.enforcementId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.enforcementDetailsForm.parsley().whenValidate();
  },

  getFormData: function() {
    return this.enforcementDetailsForm.getFormData();
  }
});
